import React from 'react';

import styles from './TrustPilotInline.m.sass';

import trustPilotLogoImage from './assets/trustpilot.svg';
import trustPilotStarImage from './assets/star.svg';

export default function TrustPilotInline() {
  return (
    <a href="#" className={styles.trustPilot}>
      <img src={trustPilotLogoImage} className={styles.trustPilotLogo} alt="Trustpilot"/>
      <span className={styles.trustPilotStars}>
        <span className={styles.trustPilotStar}><img src={trustPilotStarImage} alt=""/></span>
        <span className={styles.trustPilotStar}><img src={trustPilotStarImage} alt=""/></span>
        <span className={styles.trustPilotStar}><img src={trustPilotStarImage} alt=""/></span>
        <span className={styles.trustPilotStar}><img src={trustPilotStarImage} alt=""/></span>
        <span className={styles.trustPilotStar}><img src={trustPilotStarImage} alt=""/></span>
      </span>
      <span className={styles.trustPilotExcellent}>Excellent</span>
    </a>
  );
}



// WEBPACK FOOTER //
// ./components/trustPilot/TrustPilotInline.js